<template>
  <div>
    <span class="text-justify data-inline-data">
      {{ this.$vuetify.lang.translator('text_legend') }}
    </span>
    <ChipList
      :item="{items: processes_list}"
    ></ChipList>
    <div class="qmkey-related-inline-table">
    
    <v-data-table
      :headers="workflowFields"
      :items="current_qunit['workflow']"
      item-key="transition_id"
      disable-pagination
      disable-filtering
      dense
      :items-per-page="1000"
      hide-default-footer
      show-expand
      class="qmkey-explorer-table-expansion-table table-contrast-expand-icon"
      disable-sort
    >
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="workflowFields.length + 1"
          class="qmkey-explorer-table-expansion-td"
        >
          <v-container>
            <v-row
              v-for="(field, index) in item.fields"
              :key="index"
              dense
              no-gutters
            >
              <v-col cols="10">
                <v-badge
                  v-if="color(field)"
                    inline
                    left
                    :color="color(field)"
                    dot
                  >
                    <span class="data-inline-data-title">
                      {{ itemLabel(field) }}:
                    </span>
                </v-badge>
                <span class="data-inline-data-title"
                  v-else
                >
                  {{ itemLabel(field) }}:
                </span>
                  <div class="values-cont">
                    <span
                       class="text-justify data-inline-data text-decoration-line-through"
                      v-if="field.props.previus_value"
                     >
                        {{ representation(field) }}
                    </span>
                    <span class="text-justify data-inline-data">
                        {{ field }}
                    </span>
                  </div>
              </v-col>            
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
    </div>
  </div>
</template>

<script>
import Field from '@/components/qfields/Field'
import InlineBoxSimpleLayout from './InlineBoxSimpleLayout.vue';
import ChipList from '@/components/explorer/chips/ChipList';

export default {
  name: 'InlineBoxWorkflow',

  props: {
    current_qunit: Object,
    props: Object,
    short: {type: Boolean, default: false},
  },

  components: {
    Field,
    InlineBoxSimpleLayout,
    ChipList,
  },

  data() {
    return {
      extended: [],
      value: true,
      legend: [
          {
            "name":this.$vuetify.lang.translator('text_new'),
            "color":"green"
          }, 
          {
            "name":this.$vuetify.lang.translator('text_modify'),
            "color":"red"
          }
      ]
    }
  },

  methods: {
    itemLabel(item) {
      try {
        return item.props.label
      } catch (error) {
        console.warn(item)
      }
      return ''
    },
    color(item) {
      try {
        return  item.props.class == "field_value_new" 
          ? "green" 
          : item.props.class == "field_value_changed" 
            ? "red"
            : ""; //just show changed
      } catch (error) {
        console.warn(item)
      }
      return 'black'
    },

    representation(item) {
      return item.clone(
        { ...item.props, value: item.props.previus_value.value, readable: item.props.previus_value.readable });
    }
  },

  computed: {
    workflowFields() {
      const inline_workflow = this.current_qunit.inline_boxes.filter(
        x => x.type == 'inline-box-workflow',
      )[0]
      return [
        ...inline_workflow.columns,
        { value: 'data-table-expand', text: '', sortable: false },
      ]
    },
    processes_list() {
        return this.legend.map(itm => ({
            component: 'ChipGeneric',
            name: 'legend_'+itm.name,
            readable: "Dato ",
            value: itm.name,
            readableValue: itm.name,
            color: itm.color,
            icon:'mdi-circle-small',
        }))
    },    
  },
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
@import '@/sass/explorer/inline.scss';
</style>
<style scoped>
.text-block {
  white-space: pre-line;
}
.values-cont {
   display: flex;
   gap: .5em;
   align-items: center;
   justify-content: space;
 }
</style>
